module.exports = __webpack_public_path__ + "static/gallery-7-925c33cb19556384d5f60513b6372795.jpg";